import React, { useMemo } from "react";

interface Props {
  volume: number;
}

const rows = 10;
const columns = 1;

const height = 50;

const LinearAudioLevelIndicator = ({ volume }: Props) => {
  const style = useMemo(
    () => ({
      height: `${height - Math.min(volume * height * 3, height)}px`,
    }),
    [volume],
  );
  return (
    <div className="container">
      {[...Array(rows * columns)].map(() => (
        <div className="cell" />
      ))}
      <div className="overlay" style={style} />
      <style jsx>{`
        .cell {
          border: solid 1px black;
        }
        .container {
          width: 10px;
          height: ${height}px;
          background: linear-gradient(
            0deg,
            #00c100 0%,
            yellow 50%,
            #ff2222 100%
          );
          position: relative;
          display: grid;
          grid-template-columns: repeat(${columns}, 1fr);
          grid-template-rows: repeat(${rows}, 1fr);
        }
        .overlay {
          background: black;
          position: absolute;
          top: 0;
          width: 100%;
          transition: height 0.5s linear;
        }
      `}</style>
    </div>
  );
};

export default LinearAudioLevelIndicator;
